import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';

import Message from 'common/message/Message';
import OAuthFlows from 'common/OAuthFlows';
import devURL from 'common/util/devURL';
import queryString from 'common/util/queryString';

const DevOrigin = 'https://canny.localhost:8007';
const Origin = devURL('https://auth.canny.io');

class AuthRedirect extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        authType: PropTypes.string,
        close: PropTypes.bool,
        redirectURL: PropTypes.string,
        separateWindow: PropTypes.bool,
        stage: PropTypes.string,
      }),
    }),
  };

  componentDidMount() {
    const { query } = this.props.location;
    const result = Object.assign({}, query);
    if (result.state) {
      try {
        const parsedState = JSON.parse(result.state);
        Object.keys(parsedState).forEach((parsedKey) => {
          result[parsedKey] = parsedState[parsedKey];
        });
        delete result.state;
      } catch (e) {
        console.warn(e);
      }
    }

    const { authType, close, dev, stage, redirectURL, separateWindow } = result;

    if (dev && !__DEV__) {
      window.location =
        DevOrigin + window.location.pathname + window.location.search + window.location.hash;
      return;
    }

    if (close && window.opener) {
      Message.postMessage(window.opener, '*', 'authResult', result);
      window.close();
      return;
    }

    this._result = result;

    if (String(stage) === '2') {
      this.onOAuthContinue();
      return;
    }

    const OAuthFlow = OAuthFlows.getFlow(authType);
    const oauthFlow = new OAuthFlow({
      onContinue: this.onOAuthContinue,
      onFailure: this.onOAuthFailure,
      onSuccess: this.onOAuthSuccess,
      redirectURL,
      separateWindow,
      shouldOpenNewTab: false,
    });
    oauthFlow.connect();
  }

  componentWillUnmount() {
    this._result = null;
  }

  onOAuthContinue = () => {
    const result = this._result || this.props.location.query;
    const { authType, redirectURL, separateWindow } = result;
    const OAuthFlow = OAuthFlows.getFlow(authType, 2);
    const oauthFlow = new OAuthFlow({
      onContinue: this.onOAuthContinue,
      onFailure: this.onOAuthFailure,
      onSuccess: this.onOAuthSuccess,
      redirectURL,
      separateWindow,
      shouldOpenNewTab: false,
    });
    oauthFlow.connect(result);
  };

  onOAuthFailure = (error) => {
    const result = this._result || this.props.location.query;
    const { authType, redirectURL, separateWindow } = result;

    if (redirectURL) {
      if (!redirectURL.startsWith('http')) {
        throw new Error('invalid redirectURL');
      }
      const query = queryString.stringify({
        authType,
        error,
        failed: true,
      });
      if (redirectURL.indexOf('?') !== -1) {
        window.location.replace(redirectURL + '&' + query.slice(1));
      } else {
        window.location.replace(redirectURL + query);
      }
    } else if (separateWindow && window.opener) {
      Message.postMessage(window.opener, Origin, 'authResult', {
        error,
        result: 'failure',
      });
      window.close();
    } else {
      console.log('Something went wrong :/');
    }
  };

  onOAuthSuccess = (oauthData) => {
    const result = this._result || this.props.location.query;
    const { authType, redirectURL, separateWindow } = result;

    if (redirectURL) {
      if (!redirectURL.startsWith('http')) {
        throw new Error('invalid redirectURL');
      }
      const query = queryString.stringify({
        ...oauthData,
        authType,
        success: true,
      });
      if (redirectURL.indexOf('?') !== -1) {
        window.location.replace(redirectURL + '&' + query.slice(1));
      } else {
        window.location.replace(redirectURL + query);
      }
    } else if (separateWindow && window.opener) {
      Message.postMessage(window.opener, Origin, 'authResult', {
        oauthData,
        result: 'success',
      });
      window.close();
    } else {
      console.log('Something went wrong :/');
    }
  };

  render() {
    return <div />;
  }
}

export default hot(AuthRedirect);
